export default __webpack_public_path__ + "static/media/kopa-logo.62fc89cb.svg";